import React from "react";
const InfoItem = props => {
  const {label, value} = props;
  return (
    <div>
      <span> • {label}</span>: <span>{value}</span>
    </div>
  );
};
export default InfoItem;
